export default __webpack_public_path__ + "static/media/Sendoffwidgetbutton.6b6be0dc.svg";